export default __webpack_public_path__ + "static/media/maternidad1_g.8b15be69.jpg";